export default {
    comparison: {
        comparisonOptions: {
            leftType: "contextProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    equals: {
        equalsOptions: {
            leftType: "contextProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    fuzzyMatch: {
        fuzzyMatchOptions: {
            leftType: "contextProperty",
            leftValue: "itemId",
            rightType: "constantValue",
            rightValue: ""
        }
    },
    startsWith: {
        startsWithOptions: {
            prefixType: "contextProperty",
            prefixValue: "itemId",
            fullTextType: "constantValue",
            fullTextValue: ""
        }
    },
    hasValue: {
        hasValueOptions: {
            propertyType: "contextProperty",
            propertyValue: "itemId"
        }
    },
    hasEvent: {
        hasEventOptions: {
            hasEventType: "constantValue",
            hasEventValue: ""
        }
    },
    fullTextSearch: {
        fullTextSearchOptions: {
            searchInType: "contextProperty",
            searchInValue: "itemId",
            searchStringType: "constantValue",
            searchStringValue: "",
        }
    }
}